import React from "react";
import {
  Box,
  Button,
  Grid2,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";

// import dashboard from "../../../../Images/EAM/Dashboard.png";
// import formList from "../../../../Images/EAM/formlist.png";
// import formPage from "../../../../Images/EAM/formpage.png";
// import wave from "../../../../Images/aboutUsBg.jpg";
// import wave from "../../../../Images/aboutUsBg.jpg";
import { commonCss } from "../../../../CssStyle/commonCss";
import WaveBackground from "../../../../Component/WaveBackground";
import { Done } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const EAM = () => {
  const navigate = useNavigate();
  return (
    <Grid2 container spacing={"2rem"}>
      <WaveBackground
        menu={"Our Products"}
        title={"Enterprise Asset Management"}
        description={
          "Enhancing Psset Performance Through Strategic Lifecycle Management."
        }
      />

      <Grid2 container justifyContent={"center"}>
        <Grid2
          container
          size={12}
          spacing={"1rem"}
          sx={{
            padding: { xs: "1.5rem", md: "0 3rem 3rem 3rem" },
            maxWidth: { xs: "auto", xl: "2000px" },
          }}
          alignItems={"center"}
          mt="-10%"
        >
          <Grid2
            container
            size={{ xs: 12, md: 6 }}
            justifyContent={{ xs: "center", md: "flex-start" }}
          >
            {/* <Box sx={{display:'flex',width:"100%",height:"fit-content",alignItems:"center",gap:"1rem"}}>
            <img src={dashboard} style={{width:'60%',height:"50vh",borderRadius:"10px",border:"5px solid #474747"}}/>
            <img src={dashboard_mobile} style={{width:'20%',height:"40vh",borderRadius:"10px",border:"5px solid #474747"}}/>
            </Box> */}
            <img
              src={"/Images/EAM/Dashboard.png"}
              alt="EAM dashboard"
              style={{ width: "85%", height: "100%" }}
            />
          </Grid2>
          <Grid2
            size={{ xs: 12, md: 6 }}
            sx={{
              pr: {
                xs: 0,
                md: "3rem",
                fontFamily: "Roboto, Arial, sans-serif",
              },
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "35px", md: "40px" },
                textAlign: { xs: "center", md: "left" },
                fontWeight: 700,
                fontFamily: "inherit",
              }}
            >
              EAM Web & Mobile App
            </Typography>
            <Typography
              variant="h1"
              sx={{
                letterSpacing: 0.3,
                lineHeight: 1.5,
                fontWeight: 300,
                fontFamily: "inherit",
                fontSize: "20px",
                mt: "1rem",
              }}
            >
              A{" "}
              <span style={{ color: commonCss.orange, fontWeight: 600 }}>
                Enterprise Asset Management (EAM) solution
              </span>{" "}
              designed to optimize the management of your organization’s assets
              throughout their entire lifecycle, from asset acquisition to
              disposal. EAM empowers you to maximize asset performance, minimize
              downtime, and drive operational efﬁency across your enterprise.
              Say goodbye to fragmanted asset management processes and embrace a
              uniﬁed approach with our cutting-edge EAM Solution.
            </Typography>

            <Typography
              sx={{
                fontSize: "1.1rem",
                fontWeight: 700,
                fontFamily: "inherit",
                mt: 4,
              }}
            >
              Key Features
            </Typography>
            <List
              sx={{
                "& .MuiListItemText-primary": {
                  fontFamily: "Roboto, sans-serif",
                  fontSize: "1rem",
                  fontWeight: 600,
                },
                display: "flex",
                columnGap: "1rem",
                flexWrap: "wrap",
                width: "100%",
                mt: 1,
              }}
            >
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Assest Management</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Workorder Management</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Inventory Management</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Mobile EAM</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>IIOT Management</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Integration Management</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Health, Safety & Environment (HSE) Management{" "}
                </ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%", md: "40%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>KPI & Dashboard</ListItemText>
              </ListItem>
            </List>
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2
        container
        justifyContent={"center"}
        sx={{ background: commonCss.backgroundGray }}
      >
        <Grid2
          container
          size={12}
          spacing={"1rem"}
          sx={{
            padding: { xs: "1.5rem", md: "3rem" },
            maxWidth: { xs: "auto", md: "2000px" },
          }}
          alignItems={"center"}
        >
          <Grid2
            size={{ xs: 12, md: 6 }}
            sx={{
              pl: {
                xs: 0,
                md: "3rem",
                fontFamily: "Roboto, Arial, sans-serif",
              },
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "35px", md: "40px" },
                fontWeight: 700,
                fontFamily: "inherit",
              }}
            >
              {" "}
              Transform your assest management practices, drive operational
              excellence and unlock new levels of efficiency and productivity.
            </Typography>
            <Typography
              variant="h1"
              sx={{
                letterSpacing: 0.3,
                lineHeight: 1.5,
                fontWeight: 300,
                fontFamily: "inherit",
                fontSize: "20px",
                mt: "1rem",
              }}
            >
              Why Use EAM?
            </Typography>

            {/* <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Key Features</Typography> */}
            <List
              sx={{
                "& .MuiListItemText-primary": {
                  fontFamily: "Roboto, sans-serif",
                  fontSize: "1rem",
                  fontWeight: 600,
                },
                display: "flex",
                columnGap: "1rem",
                flexWrap: "wrap",
                width: "100%",
                mt: 4,
              }}
            >
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Regular maintenance and monitoring reduce wear and tear.
                </ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Proactive maintenance minimizes unexpected failures.
                </ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>
                  Efficient resource management cuts maintenance and operational
                  expenses.
                </ListItemText>
              </ListItem>
            </List>
          </Grid2>
          <Grid2
            container
            size={{ xs: 12, md: 6 }}
            justifyContent={{ xs: "center", md: "flex-end" }}
          >
            <img
              src={"/Images/EAM/formlist.png"}
              alt="EAM form list"
              style={{ width: "85%", height: "100%" }}
            />
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2 container justifyContent={"center"}>
        <Grid2
          container
          size={12}
          spacing={"1rem"}
          sx={{
            padding: { xs: "1.5rem", md: "3rem 3rem 1rem 3rem" },
            maxWidth: { xs: "auto", xl: "2000px" },
          }}
          alignItems={"center"}
        >
          <Grid2
            container
            size={{ xs: 12, md: 6 }}
            justifyContent={{ xs: "center", md: "flex-start" }}
          >
            <img
              src={"/Images/EAM/formpage.png"}
              alt="EAM form page"
              style={{ width: "85%", height: "100%" }}
            />
          </Grid2>
          <Grid2
            size={{ xs: 12, md: 6 }}
            sx={{
              pr: {
                xs: 0,
                md: "3rem",
                fontFamily: "Roboto, Arial, sans-serif",
              },
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "35px", md: "40px" },
                fontWeight: 700,
                fontFamily: "inherit",
              }}
            >
              Benefits
            </Typography>
            {/* <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>A <span style={{color:commonCss.orange,fontWeight:600}}>Safety Walk</span> is a digital platform designed to streamline safety inspections, audits, and reporting processes in workplaces. It typically helps organizations ensure compliance with safety standards, identify hazards, and promote a safer environment.</Typography>
            
            <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Benefits</Typography> */}
            <List
              sx={{
                "& .MuiListItemText-primary": {
                  fontFamily: "Roboto, sans-serif",
                  fontSize: "1.1rem",
                  fontWeight: 400,
                },
                display: "flex",
                columnGap: "1rem",
                flexWrap: "wrap",
                width: "100%",
                mt: 1,
              }}
            >
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Improved the assest performance.</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Reduced downtime.</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Cost savings</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Enhanced decision-making.</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Increased efficiency.</ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Improved compliance </ListItemText>
              </ListItem>
              <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                <ListItemIcon>
                  <Done />
                </ListItemIcon>
                <ListItemText>Risk mitigation</ListItemText>
              </ListItem>
            </List>
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2
        size={12}
        container
        justifyContent={"flex-end"}
        sx={{ p: "0rem 2rem 2rem 0rem", width: { xs: "auto", xl: "2000px" } }}
      >
        <Button
          sx={{
            backgroundColor: commonCss.buttonBg,
            color: commonCss.buttonText,
            padding: "0.5rem 2rem",
            textTransform: "none",
            width: "fit-content",
            fontWeight: 500,
            fontSize: "0.95rem",
            borderRadius: "30px",
            ":hover": {
              background: commonCss.blue,
            },
            //  position: 'relative',
            //   transition: '0.3s',
            //     animation: 'glow 1.5s infinite alternate',

            //   '@keyframes glow': {
            //     '0%': {
            //       background: "#FCAE1E",
            //     },
            //     '100%': {
            //       background: commonCss.blue,
            //     },
            //   },
          }}
          onClick={() => {
            navigate("/products?productName=eam");
          }}
        >
          Explore More Products
        </Button>
        <Button
          sx={{
            backgroundColor: commonCss.buttonBg,
            color: commonCss.buttonText,
            padding: "0.5rem 2rem",
            textTransform: "none",
            width: "fit-content",
            fontWeight: 500,
            fontSize: "0.95rem",
            borderRadius: "30px",
            ":hover": {
              background: commonCss.blue,
            },
            position: "relative",
            transition: "0.3s",
            animation: "glow 1.5s infinite alternate",

            "@keyframes glow": {
              "0%": {
                background: "#FCAE1E",
              },
              "100%": {
                background: commonCss.blue,
              },
            },
          }}
          onClick={() => {
            navigate(
              "/contactus?type=Product Demo&&demo=Enterprise Asset Management"
            );
          }}
        >
          Schedule a Demo
        </Button>
      </Grid2>
    </Grid2>
  );
};

export default EAM;
